import { render, staticRenderFns } from "./UINavBtn.vue?vue&type=template&id=8c90443a&scoped=true&"
import script from "./UINavBtn.vue?vue&type=script&lang=ts&"
export * from "./UINavBtn.vue?vue&type=script&lang=ts&"
import style0 from "./UINavBtn.vue?vue&type=style&index=0&id=8c90443a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c90443a",
  null
  
)

export default component.exports